import { createContext, useContext } from 'react';
import type { OpenReports } from './openReports';

/**
 * The Brand profile badge: the checklist rows still standing, from
 * `/v1/organization/readiness`. The shell reads it once per session and the
 * profile page corrects it after its own load and after each save. D17.
 */
export const ProfileGapsContext = createContext<OpenReports>({ count: null, set: () => {} });

export const useProfileGaps = () => useContext(ProfileGapsContext);
